
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93x_45Y9Ow_45nj_ayYIS908NRMkbEauBrlPuJgFAZO2__ps8Meta } from "/codebuild/output/src485108494/src/ark/pages/[...slug].vue?macro=true";
import { default as guias_a8I5O4efmT5AEIzZQnY_457fgG8eY1IofmmcXVBqbu0UMeta } from "/codebuild/output/src485108494/src/ark/pages/blog/guias.vue?macro=true";
import { default as indexmzUmNMn6r3swZdM_2q_4529TsIcVxGbWLcxa_45T7ZVR39YMeta } from "/codebuild/output/src485108494/src/ark/pages/blog/index.vue?macro=true";
import { default as temasdRShcQtBS44NI7tfW4DV1ziUUIeJhAroWwe9lt5laBkMeta } from "/codebuild/output/src485108494/src/ark/pages/blog/temas.vue?macro=true";
import { default as pesquisaWZB8gkzzoY7VDhPy3PsawCbScCxWO6za_2_J0NgJ094Meta } from "/codebuild/output/src485108494/src/ark/pages/blog/pesquisa.vue?macro=true";
import { default as morada1NEp8ZFl3EYD5A5f15r0ebXGgzVqEWdiBBbFPov1i40Meta } from "/codebuild/output/src485108494/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/morada.vue?macro=true";
import { default as habitantes2gGkT4klItRbh_pIeUVuLMrYDAiKKSGHajZH1hCF618Meta } from "/codebuild/output/src485108494/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/habitantes.vue?macro=true";
import { default as escalao_45gasDt2Ro6k3_Of2Ve25xLz8tIHklsykMcXMJkLtAJ15yNEMeta } from "/codebuild/output/src485108494/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/escalao-gas.vue?macro=true";
import { default as tempo_45em_45casaj2jm_45P477ZDXbzdJQZ1UwYALQAr9falUH07SRLAj5tMMeta } from "/codebuild/output/src485108494/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tempo-em-casa.vue?macro=true";
import { default as tipo_45de_45produtoOrEEi5_45cIHWgBzDiKyoVkgkZjdkzgEB_45qWO9ydYep7IMeta } from "/codebuild/output/src485108494/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tipo-de-produto.vue?macro=true";
import { default as comercializadorasoaRV6kqsX9BI0qhMXyE3O2Rx0GS2HqbKbAmdGsyxv8Meta } from "/codebuild/output/src485108494/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/comercializadora.vue?macro=true";
import { default as dados_45de_45contactoE7BFGbz_45xKf_45uyYMNjehpUz4QMUwQjI0Mc8jKMvMaooMeta } from "/codebuild/output/src485108494/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/dados-de-contacto.vue?macro=true";
import { default as potencia_45contratadaPEdndBVCUNgtgouhpdJtx7t4Lgh7wWE8LyD9ajJYY8sMeta } from "/codebuild/output/src485108494/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/potencia-contratada.vue?macro=true";
import { default as simular3ngmpGLmtp4WMEM9c_45q4eduNMozlXTM0ON2MdzFepy8Meta } from "/codebuild/output/src485108494/src/ark/pages/energia/simular.vue?macro=true";
import { default as internetwnFPvK0I1UFu6a6iiJ9HTb99og7MhWzbghmI4E56KGcMeta } from "/codebuild/output/src485108494/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/internet.vue?macro=true";
import { default as telemovelkDtF085M82ZtN_45iDlbS9ovSJ4ht7sGcPVuNQe_dlKdAMeta } from "/codebuild/output/src485108494/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/telemovel.vue?macro=true";
import { default as fidelizacaomHDD4QSWKtZegmY1oRErXcvUizJiv9OpXd7xq7RgdswMeta } from "/codebuild/output/src485108494/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/fidelizacao.vue?macro=true";
import { default as operadora_45atualZEggB9HGphMBd4Tv2dwFECcqQi1rNxnMiLIk8QK3qAEMeta } from "/codebuild/output/src485108494/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/operadora-atual.vue?macro=true";
import { default as dados_45de_45contactoIDKhWTc8UJ90VVdn0ho0t6gfFWIriBUwwQpUuX4h2bYMeta } from "/codebuild/output/src485108494/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/dados-de-contacto.vue?macro=true";
import { default as simularggHH8SM6wKbajK4pXgA6FjrpSs7TzsG32LwVD9tCZDwMeta } from "/codebuild/output/src485108494/src/ark/pages/tv-net-voz/simular.vue?macro=true";
import { default as _91_46_46_46slug_93jEnU9sxS37UIudJa0iSOnWo7Snu_LbVHnrvgWnuhoI4Meta } from "/codebuild/output/src485108494/src/ark/pages/blog/autor/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93e7qqhaGl4qhcPfbqTvNmX5ZJgLqRgERuNmAPP3yT_5oMeta } from "/codebuild/output/src485108494/src/ark/pages/blog/rubricas/[...slug].vue?macro=true";
import { default as resumoHHQyQO_45pmi4GO7o5wAA_lZao_HsEawh6ucHuIm2IEeMMeta } from "/codebuild/output/src485108494/src/ark/pages/depositos-a-prazo/resumo.vue?macro=true";
import { default as finalidadeyQmH6qocX8aDuBljvCuWMtj6SncVvKDAClakEDW4_4MMeta } from "/codebuild/output/src485108494/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/finalidade.vue?macro=true";
import { default as tipo_45de_45taxalkY0j1WPshWzqkLApJHSX1dA9PTEmkulPFc0z1q4CloMeta } from "/codebuild/output/src485108494/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/tipo-de-taxa.vue?macro=true";
import { default as dados_45de_45contactoUt5205KyQukJWnL_45b3p7bsD8GcX4BOPry1P2ksw8UOsMeta } from "/codebuild/output/src485108494/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/dados-de-contacto.vue?macro=true";
import { default as estado_45do_45processoZXsjlruoioWtoXzFqJftgrM_45Y7onFNmijOrTeWTZ9gYMeta } from "/codebuild/output/src485108494/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/estado-do-processo.vue?macro=true";
import { default as situacao_45financeiravZni5ylohc_gbsfq7RmQSFYyFyBNFR84ydNxziSc73oMeta } from "/codebuild/output/src485108494/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/situacao-financeira.vue?macro=true";
import { default as montante_45do_45emprestimor2sM9OAk_45nr_45FTgpJpIF4c7D7aFwB48r2Cy7vei_1vwMeta } from "/codebuild/output/src485108494/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/montante-do-emprestimo.vue?macro=true";
import { default as simularYPFbNpNj1C_45T62V5sG614TAH73p9oda5DF6OzoHrL2gMeta } from "/codebuild/output/src485108494/src/ark/pages/credito-habitacao/simular.vue?macro=true";
import { default as _91_46_46_46slug_931Lod9ht1luc25ySpZlWm5L3ccqXYdrNA78balpJpVooMeta } from "/codebuild/output/src485108494/src/ark/pages/simuladores/embed/[...slug].vue?macro=true";
import { default as resultadosH8FR_BNGZYIXpapdd_45NZJSEIUfxZu4C9paCp8U8fmoIMeta } from "/codebuild/output/src485108494/src/ark/pages/credito-habitacao/resultados.vue?macro=true";
import { default as index7YNhZvF5v5QKi4Qaui5vIi42nmtSfd7e6TJuW2GRxloMeta } from "/codebuild/output/src485108494/src/ark/pages/parcerias-imobiliarias/index.vue?macro=true";
import { default as _91_46_46_46slug_936IVh7m5z5vLbm7yY3b_MoCQm4V5gTsUJzWp9oEdO7H4Meta } from "/codebuild/output/src485108494/src/ark/pages/tv-net-voz/campanhas/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93wV3sMK128Vfasm_45TjwrhEN7o7DJxpbQgpbJDnokmp84Meta } from "/codebuild/output/src485108494/src/ark/pages/parcerias-imobiliarias/[...slug].vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/codebuild/output/src485108494/src/ark/pages/[...slug].vue")
  },
  {
    name: "blog-guias",
    path: "/blog/guias",
    component: () => import("/codebuild/output/src485108494/src/ark/pages/blog/guias.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/codebuild/output/src485108494/src/ark/pages/blog/index.vue")
  },
  {
    name: "blog-temas",
    path: "/blog/temas",
    component: () => import("/codebuild/output/src485108494/src/ark/pages/blog/temas.vue")
  },
  {
    name: "blog-pesquisa",
    path: "/blog/pesquisa",
    component: () => import("/codebuild/output/src485108494/src/ark/pages/blog/pesquisa.vue")
  },
  {
    name: "energia-simular",
    path: "/energia/simular",
    meta: { ...(simular3ngmpGLmtp4WMEM9c_45q4eduNMozlXTM0ON2MdzFepy8Meta || {}), ...{"middleware":["funnel"]} },
    component: () => import("/codebuild/output/src485108494/src/ark/pages/energia/simular.vue"),
    children: [
  {
    name: "energia-simular-morada",
    path: "morada",
    component: () => import("/codebuild/output/src485108494/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/morada.vue")
  },
  {
    name: "energia-simular-habitantes",
    path: "habitantes",
    component: () => import("/codebuild/output/src485108494/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/habitantes.vue")
  },
  {
    name: "energia-simular-escalao-gas",
    path: "escalao-gas",
    component: () => import("/codebuild/output/src485108494/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/escalao-gas.vue")
  },
  {
    name: "energia-simular-tempo-em-casa",
    path: "tempo-em-casa",
    component: () => import("/codebuild/output/src485108494/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tempo-em-casa.vue")
  },
  {
    name: "energia-simular-tipo-de-produto",
    path: "tipo-de-produto",
    component: () => import("/codebuild/output/src485108494/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tipo-de-produto.vue")
  },
  {
    name: "energia-simular-comercializadora",
    path: "comercializadora",
    component: () => import("/codebuild/output/src485108494/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/comercializadora.vue")
  },
  {
    name: "energia-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src485108494/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/dados-de-contacto.vue")
  },
  {
    name: "energia-simular-potencia-contratada",
    path: "potencia-contratada",
    component: () => import("/codebuild/output/src485108494/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/potencia-contratada.vue")
  }
]
  },
  {
    name: "tv-net-voz-simular",
    path: "/tv-net-voz/simular",
    meta: { ...(simularggHH8SM6wKbajK4pXgA6FjrpSs7TzsG32LwVD9tCZDwMeta || {}), ...{"middleware":["funnel"]} },
    component: () => import("/codebuild/output/src485108494/src/ark/pages/tv-net-voz/simular.vue"),
    children: [
  {
    name: "tv-net-voz-simular-internet",
    path: "internet",
    component: () => import("/codebuild/output/src485108494/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/internet.vue")
  },
  {
    name: "tv-net-voz-simular-telemovel",
    path: "telemovel",
    component: () => import("/codebuild/output/src485108494/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/telemovel.vue")
  },
  {
    name: "tv-net-voz-simular-fidelizacao",
    path: "fidelizacao",
    component: () => import("/codebuild/output/src485108494/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/fidelizacao.vue")
  },
  {
    name: "tv-net-voz-simular-operadora-atual",
    path: "operadora-atual",
    component: () => import("/codebuild/output/src485108494/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/operadora-atual.vue")
  },
  {
    name: "tv-net-voz-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src485108494/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/dados-de-contacto.vue")
  }
]
  },
  {
    name: "blog-autor-slug",
    path: "/blog/autor/:slug(.*)*",
    component: () => import("/codebuild/output/src485108494/src/ark/pages/blog/autor/[...slug].vue")
  },
  {
    name: "blog-rubricas-slug",
    path: "/blog/rubricas/:slug(.*)*",
    component: () => import("/codebuild/output/src485108494/src/ark/pages/blog/rubricas/[...slug].vue")
  },
  {
    name: "depositos-a-prazo-resumo",
    path: "/depositos-a-prazo/resumo",
    component: () => import("/codebuild/output/src485108494/src/ark/pages/depositos-a-prazo/resumo.vue")
  },
  {
    name: "credito-habitacao-simular",
    path: "/credito-habitacao/simular",
    meta: { ...(simularYPFbNpNj1C_45T62V5sG614TAH73p9oda5DF6OzoHrL2gMeta || {}), ...{"middleware":["funnel"]} },
    component: () => import("/codebuild/output/src485108494/src/ark/pages/credito-habitacao/simular.vue"),
    children: [
  {
    name: "credito-habitacao-simular-finalidade",
    path: "finalidade",
    component: () => import("/codebuild/output/src485108494/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/finalidade.vue")
  },
  {
    name: "credito-habitacao-simular-tipo-de-taxa",
    path: "tipo-de-taxa",
    component: () => import("/codebuild/output/src485108494/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/tipo-de-taxa.vue")
  },
  {
    name: "credito-habitacao-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src485108494/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/dados-de-contacto.vue")
  },
  {
    name: "credito-habitacao-simular-estado-do-processo",
    path: "estado-do-processo",
    component: () => import("/codebuild/output/src485108494/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/estado-do-processo.vue")
  },
  {
    name: "credito-habitacao-simular-situacao-financeira",
    path: "situacao-financeira",
    component: () => import("/codebuild/output/src485108494/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/situacao-financeira.vue")
  },
  {
    name: "credito-habitacao-simular-montante-do-emprestimo",
    path: "montante-do-emprestimo",
    component: () => import("/codebuild/output/src485108494/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/montante-do-emprestimo.vue")
  }
]
  },
  {
    name: "simuladores-embed-slug",
    path: "/simuladores/embed/:slug(.*)*",
    meta: _91_46_46_46slug_931Lod9ht1luc25ySpZlWm5L3ccqXYdrNA78balpJpVooMeta || {},
    component: () => import("/codebuild/output/src485108494/src/ark/pages/simuladores/embed/[...slug].vue")
  },
  {
    name: "credito-habitacao-resultados",
    path: "/credito-habitacao/resultados",
    meta: resultadosH8FR_BNGZYIXpapdd_45NZJSEIUfxZu4C9paCp8U8fmoIMeta || {},
    component: () => import("/codebuild/output/src485108494/src/ark/pages/credito-habitacao/resultados.vue")
  },
  {
    name: "parcerias-imobiliarias",
    path: "/parcerias-imobiliarias",
    component: () => import("/codebuild/output/src485108494/src/ark/pages/parcerias-imobiliarias/index.vue")
  },
  {
    name: "tv-net-voz-campanhas-slug",
    path: "/tv-net-voz/campanhas/:slug(.*)*",
    meta: _91_46_46_46slug_936IVh7m5z5vLbm7yY3b_MoCQm4V5gTsUJzWp9oEdO7H4Meta || {},
    component: () => import("/codebuild/output/src485108494/src/ark/pages/tv-net-voz/campanhas/[...slug].vue")
  },
  {
    name: "parcerias-imobiliarias-slug",
    path: "/parcerias-imobiliarias/:slug(.*)*",
    meta: _91_46_46_46slug_93wV3sMK128Vfasm_45TjwrhEN7o7DJxpbQgpbJDnokmp84Meta || {},
    component: () => import("/codebuild/output/src485108494/src/ark/pages/parcerias-imobiliarias/[...slug].vue")
  }
]